import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { push } from 'connected-react-router';
import { Navbar, NavbarGroup } from '@blueprintjs/core';
// import '../accounts-payable/APNavBar.scss';
import 'src/styles/components/_subNavBar.scss';

const APNavBar: React.FC = () => {
    type page = 'vendors' | 'vouchers' | 'credit-card-reconciliation' ;

    const dispatch = useDispatch();
    const [currentSection, setCurrentSection] = useState<page>(undefined);

    useEffect(() => {
        if (window.location.pathname.indexOf('/credit-card-reconciliation') >= 0) {
            setCurrentSection('credit-card-reconciliation');
        } else if (window.location.pathname.indexOf('/vouchers') >= 0) {
            setCurrentSection('vouchers');
        } else {
            setCurrentSection('vendors');
        }
    });

    const navigate = (path: string) => {
        console.log(currentSection);
        if (window.location.pathname.includes('accounts-payable/') && currentSection) {
            let newPath = path.replace('accounts-payable/', '');
            dispatch(push(newPath));
        } else {
            dispatch(push(path));
        }
    };

    const isActive = (section: string) => {
        if (section === currentSection) {
            return 'active';
        }
        return '';
    };

    return (
        <Navbar className="nav-bar">
            <NavbarGroup>
                <div className={'sub-nav-menu-item ' + isActive('vendors')} onClick={() => navigate('accounts-payable/vendors')}>
                    Vendors
                </div>
                <div className={'sub-nav-menu-item ' + isActive('vouchers')} onClick={() => navigate('accounts-payable/vouchers')}>
                    Vouchers
                </div>
                <div className={'sub-nav-menu-item ' + isActive('credit-card-reconciliation')} onClick={() => navigate('accounts-payable/credit-card-reconciliation')}>
                    Credit Card Reconciliation
                </div>
            </NavbarGroup>
        </Navbar>
    );
};

export default APNavBar;



// WEBPACK FOOTER //
// ./src/components/accounts-payable/APNavBar.tsx